import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {StaticMethods} from '../../model/GeneralModels';

@Component({
  selector: 'app-text-field',
  template: `
    <mat-form-field>
      <input placeholder="{{fieldLabel}}" [(ngModel)]="ngModel" [ngModelOptions]="{standalone: true}" disabled>
    </mat-form-field>
  `,
  styleUrls: [
    '../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../assets/css/light.theme.css'
  ],
  styles: [`
      .form {
          margin-bottom: 2px;
      }
  `]
})
export class TextFieldComponent implements OnInit {
  // @Input() IconProvider: AppSettingsService;
  @Input() fieldLabel: string;
  @Input() ngModel: any;
  @Input() Icon: boolean;
  @Input() IconClass: string;
  @Input() fieldName: string;
  iconClass: string;

  constructor() {
    if (!this.Icon) {
      this.iconClass = 'icon ' + StaticMethods.getIcon(this.fieldName);
    }
  }

  ngOnInit() {
  }
}
